import {Box, Card, CardActionArea, CardContent, CardMedia, Chip, Divider, Grid, Typography} from '@mui/material';
import {Link} from "react-router-dom";
import ObservatoryPhoto1 from "../ObservatoryPhoto1.jpg";
import EastIcon from "@mui/icons-material/East";
import React, {useEffect, useState} from "react";


function QueueScheduleCard({queue, groupId}) {

    const [canLineUp, setCanLineUp] = useState(false);
    const queueStartTime = new Date(queue.startTime);
    const queueEndTime = new Date(queue.endTime);

    const dayAndMonth = new Intl.DateTimeFormat('en-US', {
        weekday: 'long',
        month: 'long',
        day: 'numeric'
    }).format(queueStartTime);

    const startTime12 = new Intl.DateTimeFormat('en-US', {
        hour: 'numeric',
        minute: 'numeric',
        hour12: 'true'
    }).format(queueStartTime);

    const endTime12 = new Intl.DateTimeFormat('en-US', {
        hour: 'numeric',
        minute: 'numeric',
        hour12: 'true'
    }).format(queueEndTime);

    const isQueuePast = (queueDate) => {
        const currentDateTime = new Date();
        return queueEndTime < currentDateTime;
    };

    const chipStyle = {color: "white", fontWeight: 700, fontSize: "0.8rem"};

    const renderChip = () => {
        if (queue.isActive && !isQueuePast(queueEndTime)) {
            return <Chip label="OPEN" color="success" sx={{...chipStyle}}/>;
        } else if (queue.isCancelled) {
            return <Chip label="CANCELLED" color="error" sx={{...chipStyle}}/>;
        } else if (isQueuePast(queueEndTime)) {
            return <Chip label="CLOSED" color="default" sx={{...chipStyle}}/>;
        } else {
            return <Chip label="SCHEDULED" color="default" sx={{...chipStyle}}/>;
        }
    };

    useEffect(() => {
        if(queue.isActive && !queue.isCancelled && !isQueuePast(queueEndTime)){
            setCanLineUp(true);
        } else{
            setCanLineUp(false);
        }
    }, [queue])

    const lineUpButton = () => {
        return (
            <Box sx={{pt: '15px'}}>
                <Divider/>
                <Card elevation={1} rounded="true" sx={{backgroundColor: '#A6192E', margin: '20px 0px 10px 0px', p: "0px 10px 0px 10px"}}>
                    <CardContent>
                        <Grid container>
                            <Grid item xs={9}>
                                <Typography sx={{fontSize: "1.3rem", fontWeight: 600}}>
                                    {groupId ? "View your place in-line" : "Line up for the Observatory" }
                                </Typography>
                            </Grid>
                            <Grid item xs="auto" sx={{margin: 'auto'}}>
                                <EastIcon sx={{fontSize: "3rem"}}/>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>


            </Box>
        );
    };


    return (
        <Card elevation={3} rounded="true">
            <CardMedia
                sx={{height: 70}}
                image={ObservatoryPhoto1}
                title='Observatory Photo'
            />

            <CardActionArea component={(canLineUp || groupId) ? Link : 'div'} to={(canLineUp || groupId) ? '/line-up' : undefined}>
                <CardContent sx={{paddingTop: '10px'}}>
                    <Box display="flex" justifyContent="space-between">
                        <Typography sx={{fontSize: "1rem"}} color="text.secondary" gutterBottom>
                            {queue.isCancelled ? 'Cancelled'
                                : (isQueuePast(queueEndTime) ? 'Past' :
                                    (queue.isActive ? 'Current' : 'Upcoming'))} Starry Nights
                        </Typography>
                        {renderChip()}
                    </Box>
                    <Typography sx={{fontSize: "1.4rem", fontWeight: 600}}>
                        {dayAndMonth}
                    </Typography>
                    <Typography sx={{fontSize: "1.2rem"}}>
                        {startTime12} to {endTime12}
                    </Typography>
                    {(canLineUp || groupId) &&
                        lineUpButton()}
                </CardContent>
            </CardActionArea>
        </Card>
    );
}

export default QueueScheduleCard;